export default __webpack_public_path__ + "b68eb84c5f07ede46c2a9a1d77dc6f37.png";